import React from "react";

const blockedDomains = [
  "prudentialhealth.com",
  "prudentialhealth.in",
  "prudentialplc.co.in",
  "abc.com",
  "xyz.com",
  "123.com",
  "test.com",
  "qwerty.com",
  "asdf.com ",
  "sample.com",
  "demo.com",
  "invalid.com",
  "noemail.com",
  "prudentialhealth.in",
  "prudentialhealth.co.in",
  "plc.in",
  "plc.co.in",
  "prudentialhealth.com",
  "plc.com",
  "prudential.abc.com",
  "prudentialplc.xyz.com",
  "prudentialplc.123.com",
  "prudentialplc.test.com",
  "prudentialplc.qwerty.com",
  "prudentialplc.asdf.com",
  "prudentialplc.sample.com",
  "prudentialplc.demo.com",
  "prudentialplc.invalid.com",
  "prudentialplc.noemail.com",
];

// export const indianMobileNumberRegex = /^(?!([6-9])\1{9})[6-9]\d{9}$/;
const indianMobileNumberRegex = /^[6-9]\d{9}$/;
const emailRegex = /^[\w.-]+@([\w-]+\.)+[a-zA-Z]{2,}$/;

const onlyNumbers = (
  event: React.ChangeEvent<HTMLInputElement>,
  size?: number,
  noLeadingZero?: boolean
) => {
  let value = event.target.value;
  let cursorPosition = event.target.selectionStart || 0;

  // Remove all non-numeric characters
  value = value.replace(/[^0-9]/g, "");

  // If noLeadingZero is true and first char is 0, remove it
  if (noLeadingZero && value.startsWith("0")) {
    value = value.slice(1);
  }

  // Limit size
  if (size) {
    // This will prevent adding numbers in between if length is exceeded
    if (cursorPosition < size && value.length > size) {
      value =
        value.slice(0, cursorPosition - 1) +
        value.slice(cursorPosition, size + 1);
    } else {
      value = value.slice(0, size);
    }
  }
  event.target.value = value;
};

const onlyAlphabets = (
  event: React.ChangeEvent<HTMLInputElement>,
  len: number = 50
) => {
  let { value } = event.target;
  if (value.startsWith(" ")) {
    value = value.trimStart();
  }
  value = value.charAt(0).toUpperCase() + value.slice(1);
  value = value.replace(/[^a-zA-Z ]/g, "");
  value = value.replace(/\s{2,}/g, " ");
  value = value.slice(0, len);
  event.target.value = value;
};

const validatePAN = (event: React.ChangeEvent<HTMLInputElement>) => {
  const { value } = event.target;

  if (value && !/^[A-Z]{3}P[A-Z][0-9]{4}[A-Z]$/.test(value.toUpperCase())) {
    return "Invalid PAN format. Please enter a valid 10-character PAN.";
  }

  return null;
};
export const panValidation = (e: React.ChangeEvent<HTMLInputElement>) => {
  let value = e.target.value.toUpperCase();

  // Allow only A-Z and 0-9
  value = value.replace(/[^A-Z0-9]/g, "");

  // Structure enforcement
  let formatted = "";

  // First 5 letters
  if (value.length > 0) formatted += value.slice(0, 5).replace(/[^A-Z]/g, "");
  // Next 4 digits
  if (value.length > 5) formatted += value.slice(5, 9).replace(/[^0-9]/g, "");
  // Last letter
  if (value.length > 9) formatted += value.slice(9, 10).replace(/[^A-Z]/g, "");

  e.target.value = formatted.slice(0, 10);
};


export const allowOnlyNumbers = (
  e: React.ChangeEvent<HTMLInputElement>,
  maxLength?: number
) => {
  let sanitizedValue = e.target.value.replace(/[^0-9]/g, ""); // only digits

  if (maxLength) {
    sanitizedValue = sanitizedValue.slice(0, maxLength); // limit length
  }

  e.target.value = sanitizedValue; // update UI value

  return sanitizedValue;
};

const formatAadhaarInput = (
  e: React.ChangeEvent<HTMLInputElement>,
  maxLength: number
) => {
  const input = e.target;
  let value = input.value;
  let cleaned = value.replace(/\D/g, ""); // Keeps only digits
  cleaned = cleaned.slice(0, maxLength);

  let formatted = cleaned;
  if (cleaned.length > 0) {
    formatted = cleaned.match(/.{1,4}/g)?.join("-") ?? "";
  }
  input.value = formatted;
};

const handleIFSCInput = (e: React.ChangeEvent<HTMLInputElement>) => {
  let value = e.target.value.toUpperCase(); // Ensure uppercase
  // Allow only up to 11 alphanumeric characters
  value = value.replace(/[^A-Z0-9]/g, "").slice(0, 11);
  e.target.value = value;
};

export const inputUtility = {
  onlyNumbers,
  indianMobileNumberRegex,
  emailRegex,
  blockedDomains,
  onlyAlphabets,
  validatePAN,
  panValidation,
  formatAadhaarInput,
  handleIFSCInput,
};
